import React, { useState } from 'react';
import { Container, WrapperInfo, Subtext } from './styles';

import { Unit } from '../../../../components/ServiceItem';
import { ScheduleContext } from '../../../../contexts/ScheduleContext';
import { useContextSelector } from 'use-context-selector';
import format from 'date-fns/format';
import { ptBR } from 'date-fns/locale';
import { HorizontalLine } from '../../../../components/HorizontalLine';
import { UnitCard } from './UnitCard';
import { ModalScheduleNotNecessary } from '../ModalScheduleNotNecessary';
import { ScheduleItemProps, typeLocationSchedule } from '../../../../models/Schedule';

interface UnitSelectorProps {
  openToScheduleUnits: Unit[];
  closedToScheduleUnits: Unit[];
  typePayment: string | undefined;
  onLocationSelected: (location: Unit) => void;
  selectedLocation: Unit | undefined;
  careType?: string;
  hasResource: boolean;
  schedule: ScheduleItemProps;
}

export const UnitSelector: React.FC<UnitSelectorProps> = ({
  openToScheduleUnits,
  closedToScheduleUnits,
  typePayment,
  onLocationSelected,
  selectedLocation,
  careType,
  hasResource,
  schedule
}) => {
  const [modalScheduleNotNecessaryData, setModalScheduleNotNecessaryData] = useState<Unit>();

  const [showModalScheduleNotNecessary, setModalScheduleNotNecessary] = useState(false);

  const [availableScheduleUnits, setAvailableScheduleUnits] = useState<Unit[]>([]);

  const [unavailableScheduleUnits, setUnavailableScheduleUnits] = useState<Unit[]>([]);

  const { findUnitDatesAvailable, unitDatesAvailable } = useContextSelector(ScheduleContext, state => state);

  const getclosestDateAvailable = (unitId: string) => {
    const datesAvailable = findUnitDatesAvailable(schedule.id, unitId);
    if (datesAvailable && datesAvailable.length > 0) {
      return format(new Date(datesAvailable[0] + 'T00:00:00'), 'dd/MM/yyyy', {
        locale: ptBR
      });
    }

    return '';
  };

  React.useEffect(() => {
    if (openToScheduleUnits.length === 1) {
      const firstUnit = openToScheduleUnits[0];
      if (getclosestDateAvailable(firstUnit.id_sgh + (firstUnit?.local_id || firstUnit?.locations?.[0]?.name || '')))
        onLocationSelected(firstUnit);
    }

    if (openToScheduleUnits.length && unitDatesAvailable.length) {
      const openUnits = [] as Unit[];
      const closeUnits = [] as Unit[];
      openToScheduleUnits.forEach(unit => {
        if (getclosestDateAvailable(unit.id_sgh + (unit?.local_id || unit?.locations?.[0]?.name || '')).length)
          openUnits.push(unit);
        else closeUnits.push(unit);
      });
      setAvailableScheduleUnits(openUnits);
      setUnavailableScheduleUnits(closeUnits);
    }
  }, [openToScheduleUnits, unitDatesAvailable]);

  return (
    <Container>
      <HorizontalLine />
      {careType !== typeLocationSchedule.TELEMEDICINE && (
        <WrapperInfo>
          {openToScheduleUnits.length + closedToScheduleUnits.length > 0 && (
            <>
              <Subtext>Escolha uma unidade</Subtext>
            </>
          )}
        </WrapperInfo>
      )}
      {availableScheduleUnits.map((location, index) => (
        <UnitCard
          key={location.id + index}
          onLocationSelected={() => {
            onLocationSelected(location);
          }}
          location={location}
          isChecked={selectedLocation?.id === location.id}
          closestDateAvailable={getclosestDateAvailable(
            location.id_sgh + (location?.local_id || location?.locations?.[0]?.name || '')
          )}
          isOpenToSchedule
          showRadio={openToScheduleUnits.length + closedToScheduleUnits.length !== 1}
        />
      ))}
      {closedToScheduleUnits.map(location => (
        <UnitCard
          key={location.id}
          onLocationSelected={() => {
            setModalScheduleNotNecessary(true);
            setModalScheduleNotNecessaryData(location);
          }}
          location={location}
          isChecked={selectedLocation?.id === location.id}
          closestDateAvailable={getclosestDateAvailable(
            location.id_sgh + (location?.local_id || location?.locations?.[0]?.name || '')
          )}
          isOpenToSchedule={false}
        />
      ))}
      {unavailableScheduleUnits.map((location, index) => (
        <UnitCard
          key={location.id + index}
          onLocationSelected={() => {
            onLocationSelected(location);
          }}
          location={location}
          isChecked={selectedLocation?.id === location.id}
          closestDateAvailable={getclosestDateAvailable(
            location.id_sgh + (location?.local_id || location?.locations?.[0]?.name || '')
          )}
          isOpenToSchedule
        />
      ))}
      <ModalScheduleNotNecessary
        visible={showModalScheduleNotNecessary}
        unit={modalScheduleNotNecessaryData}
        onClickClose={() => setModalScheduleNotNecessary(false)}
      />
    </Container>
  );
};
